import { render, staticRenderFns } from "./AccessadTable.vue?vue&type=template&id=1117fcc3&scoped=true&"
import script from "./AccessadTable.vue?vue&type=script&lang=js&"
export * from "./AccessadTable.vue?vue&type=script&lang=js&"
import style0 from "./AccessadTable.vue?vue&type=style&index=0&id=1117fcc3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1117fcc3",
  null
  
)

export default component.exports